/* @flow */

import React from "react";
import { ButtonLink as ButtonLinkComponent } from "@crossroads/ui-components";

import styles from "./styles.scss";
import cn from "classnames";

type Props = {
  children: React$Node,
  className?: string,
  to: string,
  external?: boolean,
};

const ButtonLink = ({ children, className, to, external = false, ...props }: Props): React$Node => {
  return (
    <ButtonLinkComponent
      {...props}
      to={to}
      className={cn(styles.button, className)}
      style={{ textDecoration: "none" }}
      target={external ? "_blank" : "_self"}
    >
      <span className={styles.content}>
        {children}
      </span>
      <span className={styles.content__left} />
      <span className={styles.content__right} />
    </ButtonLinkComponent>
  );
};

export default ButtonLink;
